import {HierarchyNodeMetadata} from '@domain/shared'

export type HierarchyNode = Omit<HierarchyNodeMetadata, 'children'> & {
  isAllowed: boolean
  children: HierarchyNode[]
}

export type HierarchyIdParams = {
  areaId?: string
  regionId?: string
  countryId?: string
  plantId?: string
}
